module.exports = __webpack_public_path__ + "img/st_logo.04d52060.png";